import styled from '@emotion/styled';
import { Prismic } from '@landsbankinn/prismic';
import { Segment, useMedia } from '@landsbankinn/ui';
import React from 'react';
import {
  HeadingText,
  TableWithLargeText,
} from '../components/table/TableWithLargeText';

interface IProps {
  fields: IField[];
  text: Prismic.RichText;
}

interface IField {
  text_1: Prismic.RichText;
  text_2: Prismic.RichText;
  text_3: Prismic.RichText;
  text_4: Prismic.RichText;
  text_5: Prismic.RichText;
  isheader: boolean;
  isfooter: boolean;
  bold: boolean;
}

const Div = styled.div`
  max-width: 979px;
  margin: 0 auto;
`;
const GrayBackground = styled.div`
  background-color: ${(props) => props.theme.colors.backgroundAlt};
  padding-top: 80px;
  padding-bottom: 80px;
`;
const Table = styled.table`
  margin-bottom: 20px;
`;

const BoldTR = styled.tr<{ bold?: boolean }>`
  ${(props) => (props.bold ? 'td{font-weight:bold;}' : '')};
`;
export const TableWithLargeTextContainer = ({ fields, text }: IProps) => {
  const isMobile = useMedia('sm');
  if (fields === null) {
    return null;
  }

  const header = fields.find((x) => x.isheader);

  const footer = fields.find((x) => x.isfooter);
  return (
    <Segment>
      <GrayBackground>
        <Div>
          {Prismic.text(text) && (Prismic.text(text)?.length ?? 0) > 0 && (
            <HeadingText>{Prismic.text(text)}</HeadingText>
          )}
          <TableWithLargeText>
            <>
              {!isMobile && (
                <table>
                  {header !== undefined && (
                    <thead>
                      <tr>
                        <th>{Prismic.text(header?.text_1)}</th>
                        {Prismic.text(header?.text_2) &&
                          (Prismic.text(header?.text_2) as any)?.length > 0 && (
                            <th align="center">
                              {Prismic.text(header?.text_2)}
                            </th>
                          )}
                        {Prismic.text(header?.text_3) &&
                          (Prismic.text(header?.text_3) as any)?.length > 0 && (
                            <th align="center">
                              {Prismic.text(header?.text_3)}
                            </th>
                          )}
                        {Prismic.text(header?.text_4) &&
                          (Prismic.text(header?.text_4) as any)?.length > 0 && (
                            <th align="center">
                              {Prismic.text(header?.text_4)}
                            </th>
                          )}
                        {Prismic.text(header?.text_5) &&
                          (Prismic.text(header?.text_5) as any)?.length > 0 && (
                            <th align="center">
                              {Prismic.text(header?.text_5)}
                            </th>
                          )}
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    {fields.map((item, index) => {
                      if (item.isheader) {
                        return <React.Fragment key={`tr-${index}`} />;
                      } else if (item.isfooter) {
                        return <React.Fragment key={`tr-${index}`} />;
                      } else {
                        return (
                          <BoldTR key={`tr-${index}`} bold={item.bold}>
                            {Prismic.text(item.text_1) &&
                              (Prismic.text(item.text_1) as any)?.length >
                                0 && <td>{Prismic.text(item.text_1)}</td>}
                            {Prismic.text(item.text_2) &&
                              (Prismic.text(item.text_2) as any)?.length >
                                0 && <td>{Prismic.text(item.text_2)}</td>}
                            {Prismic.text(item.text_3) &&
                              (Prismic.text(item.text_3) as any)?.length >
                                0 && <td>{Prismic.text(item.text_3)}</td>}
                            {Prismic.text(item.text_4) &&
                              (Prismic.text(item.text_4) as any)?.length >
                                0 && <td>{Prismic.text(item.text_4)}</td>}
                            {Prismic.text(item.text_5) &&
                              (Prismic.text(item.text_5) as any)?.length >
                                0 && <td>{Prismic.text(item.text_5)}</td>}
                          </BoldTR>
                        );
                      }
                    })}
                  </tbody>
                  {footer !== undefined && (
                    <tfoot>
                      <tr>
                        {Prismic.text(footer?.text_1) &&
                          (Prismic.text(footer?.text_1) as any)?.length > 0 && (
                            <td>{Prismic.text(footer?.text_1)}</td>
                          )}
                        {Prismic.text(footer?.text_2) &&
                          (Prismic.text(footer?.text_2) as any)?.length > 0 && (
                            <td align="center">
                              {Prismic.text(footer?.text_2)}
                            </td>
                          )}
                        {Prismic.text(footer?.text_3) &&
                          (Prismic.text(footer?.text_3) as any)?.length > 0 && (
                            <td align="center">
                              {Prismic.text(footer?.text_3)}
                            </td>
                          )}
                        {Prismic.text(footer?.text_4) &&
                          (Prismic.text(footer?.text_4) as any)?.length > 0 && (
                            <td align="center">
                              {Prismic.text(footer?.text_4)}
                            </td>
                          )}
                        {Prismic.text(footer?.text_5) &&
                          (Prismic.text(footer?.text_5) as any)?.length > 0 && (
                            <td align="center">
                              {Prismic.text(footer?.text_5)}
                            </td>
                          )}
                      </tr>
                    </tfoot>
                  )}
                </table>
              )}
              {isMobile && (
                <>
                  {header != undefined && (
                    <h2>{Prismic.text(header.text_1)}</h2>
                  )}
                  {Prismic.text(fields[0].text_2) != undefined &&
                    (Prismic.text(fields[0].text_2) as any)?.length > 0 && (
                      <Table>
                        {header !== undefined && (
                          <thead>
                            <tr>
                              <th colSpan={2} align="center">
                                {Prismic.text(header?.text_2)}
                              </th>
                            </tr>
                          </thead>
                        )}
                        <tbody>
                          {fields.map((item, index) => {
                            if (item.isheader) {
                              return <React.Fragment key={`tr-${index}`} />;
                            } else if (item.isfooter) {
                              return <React.Fragment key={`tr-${index}`} />;
                            } else {
                              return (
                                <BoldTR key={`tr-${index}`} bold={item.bold}>
                                  <td>{Prismic.text(item.text_1)}</td>
                                  <td>{Prismic.text(item.text_2)}</td>
                                </BoldTR>
                              );
                            }
                          })}
                        </tbody>
                        {footer !== undefined && (
                          <tfoot>
                            <tr>
                              <td>{Prismic.text(footer?.text_1)}</td>
                              <td align="center">
                                {Prismic.text(footer?.text_2)}
                              </td>
                            </tr>
                          </tfoot>
                        )}
                      </Table>
                    )}
                  {Prismic.text(fields[0].text_3) != undefined &&
                    (Prismic.text(fields[0].text_3) as any)?.length > 0 && (
                      <Table>
                        {header !== undefined && (
                          <thead>
                            <tr>
                              <th colSpan={2} align="center">
                                {Prismic.text(header?.text_3)}
                              </th>
                            </tr>
                          </thead>
                        )}
                        <tbody>
                          {fields.map((item, index) => {
                            if (item.isheader) {
                              return <React.Fragment key={`tr-${index}`} />;
                            } else if (item.isfooter) {
                              return <React.Fragment key={`tr-${index}`} />;
                            } else {
                              return (
                                <BoldTR key={`tr-${index}`} bold={item.bold}>
                                  <td>{Prismic.text(item.text_1)}</td>
                                  <td>{Prismic.text(item.text_3)}</td>
                                </BoldTR>
                              );
                            }
                          })}
                        </tbody>
                        {footer !== undefined && (
                          <tfoot>
                            <tr>
                              <td>{Prismic.text(footer?.text_1)}</td>
                              <td align="center">
                                {Prismic.text(footer?.text_3)}
                              </td>
                            </tr>
                          </tfoot>
                        )}
                      </Table>
                    )}
                  {Prismic.text(fields[0].text_4) != undefined &&
                    (Prismic.text(fields[0].text_4) as any)?.length > 0 && (
                      <Table>
                        {header !== undefined && (
                          <thead>
                            <tr>
                              <th colSpan={2} align="center">
                                {Prismic.text(header?.text_4)}
                              </th>
                            </tr>
                          </thead>
                        )}
                        <tbody>
                          {fields.map((item, index) => {
                            if (item.isheader) {
                              return <React.Fragment key={`tr-${index}`} />;
                            } else if (item.isfooter) {
                              return <React.Fragment key={`tr-${index}`} />;
                            } else {
                              return (
                                <BoldTR key={`tr-${index}`} bold={item.bold}>
                                  <td>{Prismic.text(item.text_1)}</td>
                                  <td>{Prismic.text(item.text_4)}</td>
                                </BoldTR>
                              );
                            }
                          })}
                        </tbody>
                        {footer !== undefined && (
                          <tfoot>
                            <tr>
                              <td>{Prismic.text(footer?.text_1)}</td>
                              <td align="center">
                                {Prismic.text(footer?.text_4)}
                              </td>
                            </tr>
                          </tfoot>
                        )}
                      </Table>
                    )}
                  {Prismic.text(fields[0].text_5) != undefined &&
                    (Prismic.text(fields[0].text_5) as any)?.length > 0 && (
                      <table>
                        {header !== undefined && (
                          <thead>
                            <tr>
                              <th colSpan={2} align="center">
                                {Prismic.text(header?.text_5)}
                              </th>
                            </tr>
                          </thead>
                        )}
                        <tbody>
                          {fields.map((item, index) => {
                            if (item.isheader) {
                              return <React.Fragment key={`tr-${index}`} />;
                            } else if (item.isfooter) {
                              return <React.Fragment key={`tr-${index}`} />;
                            } else {
                              return (
                                <BoldTR key={`tr-${index}`} bold={item.bold}>
                                  <td>{Prismic.text(item.text_1)}</td>
                                  <td>{Prismic.text(item.text_5)}</td>
                                </BoldTR>
                              );
                            }
                          })}
                        </tbody>
                        {footer !== undefined && (
                          <tfoot>
                            <tr>
                              <td>{Prismic.text(footer?.text_1)}</td>
                              <td align="center">
                                {Prismic.text(footer?.text_5)}
                              </td>
                            </tr>
                          </tfoot>
                        )}
                      </table>
                    )}
                </>
              )}
            </>
          </TableWithLargeText>
        </Div>
      </GrayBackground>
    </Segment>
  );
};
